import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardHeader, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';
import { CustomCard } from '../../../ProgramOnboarding/Components/Comman';
import { GET_PROJECT_LIST } from '../../../../../../../store/actions';
import { ChevronLeft } from 'react-feather';

const SelectProjects = ({ state, setState, setFormCount }) => {
  const dispatch = useDispatch();

  const [selectedProjects, setSelectedProjects] = useState<any[]>([]);

  const { getProjectList } = useSelector((state: any) => ({
    getProjectList: state.GetProjectList?.data,
  }));

  useEffect(() => {
    const airportIds = state?.vendorPricing?.airports?.map(airport => airport?.id);
    dispatch({
      type: GET_PROJECT_LIST,
      payload: {
        data: airportIds,
      },
    });
  }, [dispatch]);

  useEffect(() => {
    if (state?.multiProjects) {
      setSelectedProjects(state?.multiProjects ?? []);
    }
  }, [state]);

  const handleSubmit = () => {
    if (selectedProjects.length === 0) {
      cogoToast.error('Please select at least one project before continuing');
      return;
    }

    // save in parent state
    setState(prev => ({
      ...prev,
      multiProjects: selectedProjects,
    }));

    setFormCount(prev => prev + 1);
  };

  const handleProjectClick = (project: any) => {
    const alreadySelected = selectedProjects.some(p => p.id === project.id);

    if (alreadySelected) {
      // remove project from selection
      setSelectedProjects(prev => prev.filter(p => p.id !== project.id));
    } else {
      // add project to selection
      setSelectedProjects(prev => [...prev, project]);
    }
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Vendor Onboarding`}
              navigationby={'breadcrumNavigationHandler'}
              navigation={['Management', 'Inventory', 'Onboarding', 'Select Projects']}
            />
          </div>
        </div>

        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h5 className="m-0 fw-semibold">Select Projects</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <Row className="d-flex mx-1 mt-2" style={{ height: '340px', overflowY: 'scroll' }}>
              {getProjectList?.results?.map((project: any, index: number) => {
                const isSelected = selectedProjects.some(p => p.id === project.id);
                return (
                  <CustomCard key={index} clientName={project?.name} country={''} selected={isSelected} onClick={() => handleProjectClick(project)} />
                );
              })}

              {getProjectList?.projects?.length === 0 && <div className="text-center text-muted mt-3">No projects found</div>}
            </Row>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount(prev => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC',
              color: '#404B7C',
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>

          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>

        <div className="d-flex justify-content-end"></div>
      </Container>
    </div>
  );
};

export default SelectProjects;
